const personName = (user) => `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || 'TBA';

// Adds display labels to the server-provided pages using the loaded agenda items.
export function labelTableTopicsPages(pages = [], items = []) {
  const byId = new Map((Array.isArray(items) ? items : []).map(item => [String(item?.agendaItemId), item]));
  let speakerIndex = 0;
  return (Array.isArray(pages) ? pages : []).map(page => {
    const item = byId.get(String(page.agendaItemId));
    if (page.kind === 'master') {
      return { ...page, title: 'Table Topics Master', person: personName(item?.assignedUser), topic: '' };
    }
    speakerIndex += 1;
    const roleNumber = /(\d+)\s*$/.exec(item?.meetingRole?.name || '')?.[1];
    return {
      ...page,
      title: `Speaker ${roleNumber || speakerIndex}`,
      person: personName(item?.assignedUser),
      topic: String(item?.item_title || '').trim(),
    };
  });
}
